declare class EventBus {
  constructor();
  subscribe(
    eventType: string,
    callback: () => void
  ): {
    unsubscribe: () => void;
  };
  publish(eventType: string, arg?: symbol): void;
}

export type Subscriptions = {
  [key: string]: {
    [key: symbol]: (arg: symbol) => void;
  };
};

function EventBus() {
  const subscriptions: Subscriptions = {};

  const subscribe = (eventType: string, callback: () => void) => {
    const id = Symbol('id');
    if (!subscriptions[eventType]) subscriptions[eventType] = {};
    subscriptions[eventType][id] = callback;
    return {
      unsubscribe: function unsubscribe() {
        delete subscriptions[eventType][id];
        if (
          Object.getOwnPropertySymbols(subscriptions[eventType]).length === 0
        ) {
          delete subscriptions[eventType];
        }
      }
    };
  };

  const publish = (eventType: string, arg: symbol) => {
    if (!subscriptions[eventType]) return;
    Object.getOwnPropertySymbols(subscriptions[eventType]).forEach(key =>
      subscriptions[eventType][key](arg)
    );
  };

  return { subscribe, publish };
}

export default EventBus;
